module.exports = __webpack_public_path__ + "static/media/img-heritage-area1-hagihansharo.00ee1f69.jpg";